import { AxiosResponse } from "axios";
import {
    apiGet,
    apiPost,
    apiDelete,
    apiPut,
    getGlobalStates,
} from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { GET_OIDC_INTEGRATIONS, CREATE_OIDC, UPDATE_OIDC, DELETE_OIDC } from "./identityProviderPath";
import usermgtStore from "../usermgtStore";
import { usermgtSliceActions } from "../usermgtSlice";
import { oidcIdentityProviderSliceActions } from "../oidcIdentityProviderSlice";
import { levelSliceActions } from "../levelSlice";
import {
    UpdateOidcIdentityProvider,
    DeleteOidcIdentityProvider,
    AddOidcIdentityProvider,
    OidcIdentityProvider,
    OidcIdentityProviderStatus,
    OidcIdentityProviderConfig,
    OidcIdentityProviders,
    getIdentityID,
    isActiveServer,
} from "userful-chronos-app-common-js/dist/models/usermgt/oidcIdentityProviders";
import { toast } from "react-toastify";
import { ConfirmationToastContentStore } from "../../../Container/ConfirmationToastContentStore";
import { IDENTITY_PROVIDER_ERROR_KEY } from "userful-chronos-app-common-js/dist/models/usermgt/samlIdentityProviders";

const errorHandler = (err) => {
    console.debug("Error calling init app api ");
    console.debug(err);
};

const getError = (response: any) => {
    return {
        success: false,
        arg: response.data.arg ? response.data.arg : "",
        errorCode: response.data.errorCode ? response.data.errorCode : "",
        moduleID: response.data.moduleID ? response.data.moduleID : "",
        severity: response.data.severity ? response.data.severity : "",
        msg: response.data.unlocalizedMsg ? response.data.unlocalizedMsg : "",
    };
};

export const checkReponseIsValid = (name: string, response: AxiosResponse): boolean => {
    if (response.status >= 400) {
        console.log(`${name} error: ${response.status}`);
        return false;
    }
    if (!response.data || response.data.severity !== "SUCCESS") {
        console.log(`${name} empty response`);
        return false;
    }
    return true;
};

export const getOIDCDataFromServer = (token: string) => {
    const t1 = getGlobalStates().host + GET_OIDC_INTEGRATIONS;

    apiGet(t1, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            if (!checkReponseIsValid("authorize", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(oidcIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                oidcIdentityProviderSliceActions.setOIDCData(getOIDCDataAfterValidationCheck(response.data.arg)),
            );
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`receive authorize`, response.data);
        })
        .catch(() => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            console.warn("failed");
        });
};

export const addOIDCDataToServer = (token: string, data: AddOidcIdentityProvider) => {
    const t1 = getGlobalStates().host + CREATE_OIDC;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            if (!checkReponseIsValid("configure OIDC ", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(oidcIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                oidcIdentityProviderSliceActions.setOIDCData(getOIDCDataAfterValidationCheck(response.data.arg)),
            );
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setOverlay(false));
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`configure OIDC `, response.data);
            const updatedData = response.data.arg as OidcIdentityProvider;
            const displayName = updatedData.config.filter((config) => config.id.value === updatedData.id.value)[0]
                .displayName;
            const customDisplay = ConfirmationToastContentStore(displayName, "Save");
            toast(customDisplay, { containerId: "confirmationContainer" });
            // for displaying if there is error while syncing users
            const syncData = response.data.arg;
            const syncResult = syncData.status.error === true ? syncData.status.message : null;
            if (syncResult) {
                const displayError = ConfirmationToastContentStore(syncData.provider.alias, "Custom", syncResult);
                toast(displayError, { containerId: "confirmationContainer" });
            }
        })
        .catch(() => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            console.warn("failed");
        });
};

export const updateOIDCDataToServer = (token: string, data: UpdateOidcIdentityProvider) => {
    const t1 = getGlobalStates().host + UPDATE_OIDC;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            if (!checkReponseIsValid("update OIDC ", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(oidcIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                oidcIdentityProviderSliceActions.setOIDCData(getOIDCDataAfterValidationCheck(response.data.arg)),
            );
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setOverlay(false));
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`update OIDC`, response.data.arg);
            const customDisplay = ConfirmationToastContentStore(data.config[0].displayName, "Edit");
            toast(customDisplay, { containerId: "confirmationContainer" });
            // for displaying if there is error while syncing users
            const syncData = response.data.arg;
            const syncResult = syncData.status.error === true ? syncData.status.message : null;
            if (syncResult) {
                const displayError = ConfirmationToastContentStore(syncData.provider.alias, "Custom", syncResult);
                toast(displayError, { containerId: "confirmationContainer" });
            }
        })
        .catch(() => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            console.warn("failed");
        });
};

export const deleteOIDCDataToServer = (token: string, data: DeleteOidcIdentityProvider) => {
    const t1 = getGlobalStates().host + DELETE_OIDC;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            if (!checkReponseIsValid("authorize", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(oidcIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                oidcIdentityProviderSliceActions.setOIDCData(getOIDCDataAfterValidationCheck(response.data.arg)),
            );
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(oidcIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`receive authorize`, response.data);
        })
        .catch(() => {
            usermgtStore.dispatch(levelSliceActions.setActionInProgress(false));
            console.warn("failed");
        });
};

export const getOIDCDataAfterValidationCheck = (oidcData): OidcIdentityProviders => {
    let updatedOIDCDataProviders: OidcIdentityProviderStatus[] = oidcData.providers.map((s) => {
        let primaryOIDC: OidcIdentityProviderConfig = s.provider.config.find((c) => isActiveServer(c.entityId));
        let secondaryOIDC: OidcIdentityProviderConfig = s.provider.config.find((c) => !isActiveServer(c.entityId));
        if (!primaryOIDC) {
            primaryOIDC = s.provider.config[0];
            primaryOIDC = { ...primaryOIDC, entityId: getIdentityID(getGlobalStates().host) };
            if (s.provider.config.length > 1) secondaryOIDC = s.provider.config[1];
            let updatedConfig: OidcIdentityProviderConfig[] = [];
            updatedConfig.push(primaryOIDC);
            if (s.provider.config.length > 1) updatedConfig.push(secondaryOIDC);
            return {
                ...s,
                provider: { ...s.provider, config: updatedConfig },
                error: true,
                errorKey: "INVALID_OIDC_CONFIG" as IDENTITY_PROVIDER_ERROR_KEY,
                errorMassage: "",
            };
        }
        return s;
    });
    const updatedStatus: OidcIdentityProviders = { providers: updatedOIDCDataProviders };
    return updatedStatus;
};
